import React from "react";
import {
  File as FileIcon,
  FileText,
  Image as ImageIcon,
  Video,
  FileCode,
  Globe,
  Youtube,
} from "lucide-react";

export const getFileIcon = (item, size = 20) => {
  const name = item.name || "";
  const ext = (
    item.fileExtension ||
    name.split(".").pop() ||
    ""
  ).toLowerCase();
  const type = (item.fileType || "").toLowerCase();

  if (["jpg", "jpeg", "png", "gif", "svg"].includes(ext))
    return <ImageIcon size={size} className="repo-file-icon" />;

  const isVideo =
    /\.(mp4|mkv|avi|mov|wmv|flv)$/.test(name) ||
    type.includes("video") ||
    type.includes("youtube") ||
    ext === "youtube" ||
    name.includes("youtube.com") ||
    name.includes("youtu.be");

  if (isVideo) {
    if (
      type.includes("youtube") ||
      ext === "youtube" ||
      name.includes("youtube.com") ||
      name.includes("youtu.be")
    ) {
      return (
        <Youtube
          size={size}
          className="repo-file-icon"
          style={{ color: "#FF0000" }}
        />
      );
    }
    return <Video size={size} className="repo-file-icon" />;
  }

  if (type === "webpage" || ext === "webpage" || name.startsWith("http"))
    return <Globe size={size} className="repo-file-icon" />;

  if (
    [
      "pdf",
      "doc",
      "docx",
      "txt",
      "rtf",
      "odt",
      "xls",
      "xlsx",
      "ppt",
      "pptx",
    ].includes(ext) ||
    type.includes("application/")
  )
    return <FileText size={size} className="repo-file-icon" />;

  if (["js", "jsx", "html", "css", "json"].includes(ext))
    return <FileCode size={size} className="repo-file-icon" />;

  return <FileIcon size={size} className="repo-file-icon" />;
};
